export default __webpack_public_path__ + "static/media/gameInfoBgMb.3f982b39.png";